import { message } from 'ant-design-vue/es';
// import defaultSettings from '../defaultSettings';

let lessNodesAppended;

const colorList = [
  {
    key: '深蓝（默认）', color: '#2b5e7d',
  },
  // {
  //   key: '薄暮', color: '#F5222D',
  // },
  // {
  //   key: '火山', color: '#FA541C',
  // },
  // {
  //   key: '日暮', color: '#FAAD14',
  // },
  // {
  //   key: '明青', color: '#13C2C2',
  // },
  // {
  //   key: '极光绿', color: '#52C41A',
  // },
  {
    key: '极客蓝', color: '#2F54EB',
  },
  {
    key: '酱紫', color: '#722ED1',
  },
];

const updateTheme = primaryColor => {
  // Don't compile less in production!
  /* if (process.env.NODE_ENV === 'production') {
    return;
  } */
  // Determine if the component is remounted
  if (!primaryColor) {
    primaryColor = '#2CAD86'
  }
  const hideMessage = message.loading('正在编译主题！', 0);
  console.info(`正在编译主题!`)
  function buildIt() {
    // 正确的判定less是否已经加载less.modifyVars可用
    if (!window.less || !window.less.modifyVars) {
      hideMessage();
      message.error('主题切换失败，请刷新页面重试');
      return;
    }
    // less.modifyVars可用
    window.less.modifyVars({
        '@primary-color': primaryColor,
      })
      .then(() => {
        hideMessage();
      })
      .catch(() => {
        message.error('Failed to update theme');
        hideMessage();
      });
  }
  if (!lessNodesAppended) {
    // insert less.js and color.less
    const lessStyleNode = document.createElement('link');
    const lessConfigNode = document.createElement('script');
    const lessScriptNode = document.createElement('script');
    
    // 创建timeout来处理less.js加载超时情况
    const timeoutId = setTimeout(() => {
      hideMessage();
      message.error('主题切换失败，less.js加载超时');
      lessNodesAppended = false;
    }, 5000);
    
    lessStyleNode.setAttribute('rel', 'stylesheet/less');
    // 使用当前publicPath配置
    const publicPath = process.env.NODE_ENV === 'production' ? '/JoylabErasePM/csim-hxky-data-view/' : '/csim-hxky-data-view/';
    lessStyleNode.setAttribute('href', publicPath + 'color.less')
    lessConfigNode.innerHTML = `
      window.less = {
        async: true,
        env: 'production',
        javascriptEnabled: true
      };
    `;
    lessScriptNode.src = 'https://gw.alipayobjects.com/os/lib/less.js/3.8.1/less.min.js';
    lessScriptNode.async = true;
    lessScriptNode.onload = () => {
      clearTimeout(timeoutId);
      buildIt();
      lessScriptNode.onload = null;
    };
    lessScriptNode.onerror = () => {
      clearTimeout(timeoutId);
      hideMessage();
      message.error('主题切换失败，less.js加载错误');
      lessNodesAppended = false;
    };
    
    document.body.appendChild(lessStyleNode);
    document.body.appendChild(lessConfigNode);
    document.body.appendChild(lessScriptNode);
    lessNodesAppended = true;
  } else {
    buildIt();
  }
};

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  colorWeak ? document.body.classList.add('colorWeak') : document.body.classList.remove('colorWeak')
};

export { updateTheme, colorList, updateColorWeak }